import React from "react";
import SectionTitle from "../../../components/sectionTitle";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function RemoveProposalAlert({
  classes: {},
  onClose,
  onClickHandler,
  modal,
  modalKey = "alert",
}) {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.alert}
      maxWidth={"md"}
    >
      <DialogTitle id="simple-dialog-title">
        <SectionTitle title={"Confirm Deletion"} />
      </DialogTitle>
      <Box m={1}>
        <Box p={1}>
          <Typography variant="caption">
            All existing proposals will be deleted. Do you want to proceed?
          </Typography>
        </Box>
        <Box mt={3} display="flex" justifyContent="space-evenly">
          <Box>
            <Button
              type={"button"}
              variant={"contained"}
              color={"primary"}
              size={"small"}
              onClick={onClickHandler}
              fullWidth
              sx={{
                backgroundColor: "#cccccc",
                color: "#000",
                "&:hover": { backgroundColor: "#cccccc" },
              }}
            >
              Proceed
            </Button>
          </Box>

          <Box>
            <Button
              type={"button"}
              variant={"contained"}
              color={"primary"}
              size={"small"}
              onClick={(event, reason) => onClose(event, reason, modalKey)}
              fullWidth
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(RemoveProposalAlert);
